import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchUnmatchedFrollo, resolveUnmatchedFrollo } from '../../actions';

class UnmatchedFrolloPanel extends Component {
    componentDidMount() {
        this.props.fetchUnmatchedFrollo();
    }

    handleResolve = async (entryId, application_id, applicant_id) => {
        await this.props.resolveUnmatchedFrollo(entryId, application_id, applicant_id);
    };

    renderEntry = (entry) => {
        const suggestions = entry.suggested_matches || [];
        const fallbackApplicants = this.props.rows.flatMap((row) =>
            Object.values(row.applicants || {}).map((a) => ({
                application_id: row.application_id,
                applicant_id: a.id,
                applicant_name: a.name,
                row_name: row.name
            }))
        );

        return (
            <div
                key={entry._id}
                className="rounded-md p-3 mb-3"
                style={{ backgroundColor: '#FFFBEB', border: '1px solid #FCD34D' }}
            >
                <div className="flex items-center justify-between mb-1">
                    <div className="font-semibold text-sm" style={{ color: '#92400E' }}>
                        Unmatched Frollo email
                    </div>
                    <div className="text-xs" style={{ color: '#92400E' }}>
                        {entry.received_at ? new Date(entry.received_at).toLocaleString() : ''}
                    </div>
                </div>
                <div className="text-sm mb-1" style={{ color: '#78350F' }}>
                    Subject: <span className="font-medium">{entry.subject}</span>
                </div>
                <div className="text-sm mb-1" style={{ color: '#78350F' }}>
                    Parsed name: <span className="font-medium">{entry.parsed_name || '(could not parse)'}</span>
                </div>
                {entry.matcher ? (
                    <div className="text-xs mb-3" style={{ color: '#92400E' }}>
                        Matcher: <span className="font-mono">{entry.matcher}</span>
                        {typeof entry.best_score === 'number' ? (
                            <span> · best score {Math.round(entry.best_score * 100)}%</span>
                        ) : null}
                        {entry.matcher_reasoning ? (
                            <span> · "{entry.matcher_reasoning}"</span>
                        ) : null}
                    </div>
                ) : <div className="mb-2" />}

                {suggestions.length > 0 ? (
                    <div className="mb-2">
                        <div className="text-xs font-semibold uppercase mb-1" style={{ color: '#92400E' }}>
                            Suggested matches
                        </div>
                        <div className="flex flex-col gap-1">
                            {suggestions.map((s) => (
                                <button
                                    type="button"
                                    key={`${s.application_id}-${s.applicant_id}`}
                                    onClick={() => this.handleResolve(entry._id, s.application_id, s.applicant_id)}
                                    className="flex items-center justify-between text-left rounded px-3 py-2 text-sm"
                                    style={{ backgroundColor: '#FFFFFF', border: '1px solid #FCD34D', color: '#1F2937' }}
                                >
                                    <span>
                                        <span className="font-semibold">{s.applicant_name}</span>
                                        {s.tracking_status === 'archived' ? (
                                            <span style={{ color: '#94A3B8' }} className="ml-2 text-xs">(archived)</span>
                                        ) : null}
                                    </span>
                                    <span style={{ color: '#92400E' }} className="text-xs font-mono">
                                        {Math.round((s.score || 0) * 100)}%
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                ) : null}

                <details className="mt-2">
                    <summary
                        className="text-xs font-semibold cursor-pointer"
                        style={{ color: '#92400E' }}
                    >
                        Pick a different applicant
                    </summary>
                    <div className="mt-2 max-h-40 overflow-y-auto rounded border" style={{ borderColor: '#FCD34D' }}>
                        {fallbackApplicants.map((a) => (
                            <button
                                type="button"
                                key={`${a.application_id}-${a.applicant_id}`}
                                onClick={() => this.handleResolve(entry._id, a.application_id, a.applicant_id)}
                                className="block w-full text-left px-3 py-1.5 text-xs"
                                style={{ borderBottom: '1px solid #FEF3C7', backgroundColor: '#FFFFFF', color: '#1F2937' }}
                            >
                                {a.applicant_name} <span style={{ color: '#94A3B8' }}>· {a.row_name || a.application_id}</span>
                            </button>
                        ))}
                    </div>
                </details>
            </div>
        );
    };

    render() {
        const entries = this.props.unmatched || [];
        if (!entries.length) return null;
        return (
            <div className="rounded-xl p-5 mb-5" style={{ backgroundColor: '#FFFBEB', border: '1px solid #FCD34D' }}>
                <div className="flex items-center gap-2 mb-1">
                    <span
                        className="inline-flex items-center justify-center rounded-full text-[10px] font-bold"
                        style={{ width: 22, height: 22, backgroundColor: '#F59E0B', color: '#FFFFFF' }}
                    >
                        !
                    </span>
                    <h4 className="text-base font-bold" style={{ color: '#78350F' }}>
                        Unmatched Frollo emails · {entries.length}
                    </h4>
                </div>
                <p className="text-xs mb-4 ml-7" style={{ color: '#92400E' }}>
                    These bank-statement notifications couldn't be confidently matched to an applicant. Pick the right borrower below.
                </p>
                {entries.map(this.renderEntry)}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    unmatched: state.tracking.unmatched,
    rows: state.tracking.rows
});

const mapDispatchToProps = {
    fetchUnmatchedFrollo,
    resolveUnmatchedFrollo
};

export default connect(mapStateToProps, mapDispatchToProps)(UnmatchedFrolloPanel);
